import AWS from "../config/awsConfig";
import config from "../config/config";


const generateJwt3 =  async(jwt2,appCode) => {

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
    jwt2: jwt2,
    appCode: appCode.toUpperCase()
    }),
  };

  const response = await fetch(config.URL_GENERATE_JWT3, requestOptions);
  const result = await response.json();
  

  if (response.status !== 302 ) return({ code: response.status, message: result.message });  

   return { jwt3: result.jwt3 , code: 302}; 
  
}
 export default generateJwt3;